import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const ComisiaDeCultura: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Comisia de Cultură
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Membri Comisie
          </Typography>
          <Typography variant="body1">
            Comisia de Cultură se ocupă de promovarea și dezvoltarea 
            activităților culturale în cadrul eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ComisiaDeCultura;
